export const DEFAULT_PIXELS_PER_FOOT = 8;
export const DEFAULT_PIXELS_PER_INCH = DEFAULT_PIXELS_PER_FOOT / 12;

export function normalizePixelsPerInch(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return DEFAULT_PIXELS_PER_INCH;
  return parsed;
}

export function inchesToFeetInches(inches) {
  if (!Number.isFinite(inches)) return `0'-0\"`;
  const sign = inches < 0 ? '-' : '';
  const total = Math.round(Math.abs(inches));
  const feet = Math.floor(total / 12);
  const rem = total % 12;
  return `${sign}${feet}'-${rem}\"`;
}

export function feetToInches(feet) {
  const parsed = Number(feet);
  return Number.isFinite(parsed) ? parsed * 12 : 0;
}

export function pixelsToInches(pixels, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  return pixels / normalizePixelsPerInch(pixelsPerInch);
}

export function inchesToPixels(inches, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  return inches * normalizePixelsPerInch(pixelsPerInch);
}

export function pixelsToFeet(pixels, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  return pixelsToInches(pixels, pixelsPerInch) / 12;
}

export function feetToPixels(feet, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  return inchesToPixels(feetToInches(feet), pixelsPerInch);
}

export function areaPixelsToSquareFeet(areaPixels, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  const squareInches = areaPixels / Math.pow(normalizePixelsPerInch(pixelsPerInch), 2);
  return squareInches / 144;
}

export function squareFeetToPixels(areaSqFt, pixelsPerInch = DEFAULT_PIXELS_PER_INCH) {
  return areaSqFt * 144 * Math.pow(normalizePixelsPerInch(pixelsPerInch), 2);
}
